"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAnalytics = void 0;
function generateAnalytics(answerSheet) {
    answerSheet.answerSubmittedOn =
        answerSheet.answerSubmittedOn || new Date().toISOString();
    answerSheet.tagRanking = {};
    answerSheet.score = 0;
    answerSheet.avgDurationPerQuestInMs = isNaN(answerSheet.avgDurationPerQuestInMs) ? 0 : answerSheet.avgDurationPerQuestInMs;
    answerSheet.totalQuestionCount = 0;
    answerSheet.unseenQuestionCount = 0;
    answerSheet.completionRate = 0;
    answerSheet.correctAnswerCount = 0;
    answerSheet.wrongAnswerCount = 0;
    answerSheet.unAttemptedAnswerCount = 0;
    // Mark right answer
    answerSheet.questionGroups.forEach((group) => {
        group.questions.forEach((question) => {
            answerSheet.totalQuestionCount++;
            if (question.timeElapsedInMs === 0) {
                answerSheet.unseenQuestionCount++;
            }
            else {
                if (!isNaN(question.timeElapsedInMs)) {
                    answerSheet.avgDurationPerQuestInMs += question.timeElapsedInMs;
                }
            }
            if (!isNaN(question.providedAnswerIndex) &&
                question.providedAnswerIndex > -1) {
                if (question.providedAnswerIndex === question.correctAnswerIndex) {
                    // Correct
                    question.score = answerSheet.correctAnswerScore;
                    question.hasCorrectlyMarked = true;
                    answerSheet.score += answerSheet.correctAnswerScore;
                    answerSheet.score = parseFloat(answerSheet.score.toFixed(2));
                    answerSheet.correctAnswerCount++;
                }
                else {
                    // Incorrect
                    question.score = answerSheet.wrongAnswerScore;
                    question.hasCorrectlyMarked = false;
                    answerSheet.score += answerSheet.wrongAnswerScore;
                    answerSheet.score = parseFloat(answerSheet.score.toFixed(2));
                    answerSheet.wrongAnswerCount++;
                }
            }
            else {
                // Unattended
                question.score = answerSheet.unAnsweredScore;
                question.hasCorrectlyMarked = false;
                answerSheet.score += answerSheet.unAnsweredScore;
                answerSheet.score = parseFloat(answerSheet.score.toFixed(2));
                answerSheet.unAttemptedAnswerCount++;
            }
        });
    });
    // Calculate avg time spent
    let avgDurationPerQuestInMs = answerSheet.avgDurationPerQuestInMs /
        /** No of Questions seen */ (answerSheet.totalQuestionCount -
            answerSheet.unseenQuestionCount);
    if (!isNaN(avgDurationPerQuestInMs)) {
        answerSheet.avgDurationPerQuestInMs = avgDurationPerQuestInMs;
    }
    else {
        answerSheet.avgDurationPerQuestInMs = 0;
    }
    answerSheet.effectiveExamDurationInSec =
        answerSheet.examDurationInMinutes * 60 -
            answerSheet.elapsedTimeInMilliseconds;
    if (isNaN(answerSheet.effectiveExamDurationInSec)) {
        answerSheet.effectiveExamDurationInSec = 0;
    }
    // Calculate completion rate
    answerSheet.completionRate =
        ((answerSheet.correctAnswerCount + answerSheet.wrongAnswerCount) /
            answerSheet.totalQuestionCount) *
            100;
    if (isNaN(answerSheet.completionRate)) {
        answerSheet.completionRate = 0;
    }
    // Calculate performance
    const performance = parseFloat(((answerSheet.score / answerSheet.totalMarks) * 100).toFixed(2));
    answerSheet.performance = 0;
    if (!isNaN(performance)) {
        answerSheet.performance = performance;
    }
    // check isNan
    if (isNaN(answerSheet.score))
        answerSheet.score = 0;
    if (isNaN(answerSheet.correctAnswerCount))
        answerSheet.correctAnswerCount = 0;
    if (isNaN(answerSheet.wrongAnswerCount))
        answerSheet.wrongAnswerCount = 0;
    if (isNaN(answerSheet.unAttemptedAnswerCount))
        answerSheet.unAttemptedAnswerCount = 0;
    if (isNaN(answerSheet.performanceRate))
        answerSheet.performanceRate = 0;
    if (isNaN(answerSheet.tagRanking))
        answerSheet.tagRanking = -1;
    if (isNaN(answerSheet.totalQuestionCount))
        answerSheet.totalQuestionCount = 0;
    if (isNaN(answerSheet.unseenQuestionCount))
        answerSheet.unseenQuestionCount = 0;
    if (isNaN(answerSheet.avgDurationPerQuestInMs))
        answerSheet.avgDurationPerQuestInMs = 0;
    if (isNaN(answerSheet.effectiveExamDurationInSec))
        answerSheet.effectiveExamDurationInSec = 0;
    if (isNaN(answerSheet.completionRate))
        answerSheet.completionRate = 0;
    if (isNaN(answerSheet.performance))
        answerSheet.performance = 0;
    if (isNaN(answerSheet.rank))
        answerSheet.rank = -1;
    if (isNaN(answerSheet.totalParticipants))
        answerSheet.totalParticipants = -1;
    return answerSheet;
}
exports.generateAnalytics = generateAnalytics;
//# sourceMappingURL=Analytics.js.map